import PaginationLayout from './PaginationLayout.vue';

export default PaginationLayout;



// WEBPACK FOOTER //
// ./src/pages/activities/day/components/paginationlayout/index.ts